import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { UsuarioMini } from '@/types/api';

// Lista mini de usuarios activos (GET /api/usuarios, gestor+) para el picker
// de Responsable en alta/edición de RDT. El elenco es chico y estable (7
// personas hoy) → staleTime largo.
export function useUsuarios() {
  return useQuery({
    queryKey: ['usuarios', 'mini'],
    queryFn: () => api<{ usuarios: UsuarioMini[] }>('/api/usuarios'),
    select: data => data.usuarios,
    staleTime: 5 * 60_000,
  });
}
